Math.easeInOutQuad = function(t, b, c, d) {
  t /= d / 2
  if (t < 1) {
    return c / 2 * t * t + b
  }
  t--
  return -c / 2 * (t * (t - 2) - 1) + b
}

/** ease-out cubic：开始快、结束慢（t∈[0,d] 为时间，b 起点，c 位移量） */
Math.easeOutCubic = function(t, b, c, d) {
  t /= d
  t--
  return c * (t * t * t + 1) + b
}

// requestAnimationFrame for Smart Animating http://goo.gl/sx5sts
var requestAnimFrame = (function() {
  return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function(callback) { window.setTimeout(callback, 1000 / 60) }
})()

/**
 * Because it's so fucking difficult to detect the scrolling element, just move them all
 * @param {number} amount
 */
function move(amount) {
  document.documentElement.scrollTop = amount
  document.body.parentNode.scrollTop = amount
  document.body.scrollTop = amount
}

function position() {
  return document.documentElement.scrollTop || document.body.parentNode.scrollTop || document.body.scrollTop
}

/**
 * @param {number} to
 * @param {number} duration
 * @param {Function} callback
 */
export function scrollTo(to, duration, callback) {
  const start = position()
  const change = to - start
  const increment = 20
  let currentTime = 0
  duration = (typeof (duration) === 'undefined') ? 500 : duration
  var animateScroll = function() {
    // increment the time
    currentTime += increment
    // find the value with the quadratic in-out easing function
    var val = Math.easeInOutQuad(currentTime, start, change, duration)
    // move the document.body
    move(val)
    // do the animation unless its over
    if (currentTime < duration) {
      requestAnimFrame(animateScroll)
    } else {
      if (callback && typeof (callback) === 'function') {
        // the animation is done so lets callback
        callback()
      }
    }
  }
  animateScroll()
}

/**
 * 缓动滚动到指定位置（ease-out：先快后慢）
 * @param {number} to 目标 scrollTop
 * @param {number} duration 毫秒
 * @param {Function} [callback]
 */
export function scrollToEaseOut(to, duration, callback) {
  const start = position()
  const change = to - start
  duration = typeof duration === 'undefined' ? 650 : duration
  if (!change) {
    if (callback && typeof callback === 'function') callback()
    return
  }
  const increment = 16
  let currentTime = 0
  const animateScroll = function() {
    currentTime += increment
    const val = Math.easeOutCubic(
      Math.min(currentTime, duration),
      start,
      change,
      duration
    )
    move(val)
    if (currentTime < duration) {
      requestAnimFrame(animateScroll)
    } else {
      move(to)
      if (callback && typeof callback === 'function') callback()
    }
  }
  requestAnimFrame(animateScroll)
}
